/**
 * Created by renjie.huang on 2017/11/6.
 * 已废弃使用，修改配置移至src/conf/config.js
 */

var _devConf = {
    api:'https://api-test03.ucloudadmin.com',
    dws: 'https://dws-test03.ucloudadmin.com',
    account:'https://console-test03.ucloudadmin.com/uaccount',
    console:'https://console-test03.ucloudadmin.com',
    termUrl : 'https://docs.ucloud.cn/policy/agreement/user_agreement'
}

var _prodConf = {
    api:'https://api.ucloud.cn',
    dws: 'https://dws.ucloud.cn',
    account:'https://console.ucloud.cn/uaccount',
    console:'https://console.ucloud.cn',
    termUrl : 'https://docs.ucloud.cn/policy/agreement/user_agreement'
}

var urls;

if(!window.ENV || window.ENV == 'pre'){
    urls = _devConf;
}else{
    urls = _prodConf;
}



module.exports = urls;


// WEBPACK FOOTER //
// ./src/common/url.js